// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"823a498e1eb88b93f49d94cd9dce3080129799b5af7083a32685f51a35f220b8","node_modules_js-cookie_dist_js_cookie_mjs":"5fb1a3b9d08b34c1e59a333503c790c1f197a1dbd506c5504111418cc6bb7da6"}[chunkId] + ".js";
};